import { render } from "./CheckupForm.vue?vue&type=template&id=7e791ce0&scoped=true"
import script from "./CheckupForm.vue?vue&type=script&lang=js"
export * from "./CheckupForm.vue?vue&type=script&lang=js"

import "./CheckupForm.vue?vue&type=style&index=0&id=7e791ce0&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e791ce0"]])

export default __exports__